import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond/dist/filepond.min.css";
import AsyncCreatableSelect from "react-select/async-creatable";
import { axiosInstance } from "../../../utils/axiosInstance";
import { InputDatePicker } from "jalaali-react-date-picker";
import "jalaali-react-date-picker/lib/styles/index.css";
import DynamicForm from "../../../components/form/dynamicForm";
import { newsTypeOptions } from "../../../services/types/news";
import { DtPicker } from "react-calendar-datetime-picker";
import "react-calendar-datetime-picker/dist/style.css";
import { fetchSingleNews, updateNews } from "../../../services/news";
import Select from "react-select";
import { fetchAllCategories } from "../../../services/categories";
import type {
  FieldType,
  OptionType,
} from "../../../components/form/types/types";
import { parseIDayToDateStr, toEnDigit } from "../../../utils/time";
import { useParams } from "react-router-dom";
import moment from "moment-jalaali";
import { slugify } from "../../../utils/slug";
import { MdTurnedIn } from "react-icons/md";
// Register FilePond plugins
registerPlugin(FilePondPluginFileValidateType, FilePondPluginImagePreview);

const EditNews = () => {
  const { id } = useParams();
  console.log("editi d", id);

  useEffect(() => {
    const loadTagsOptions = async () => {
      const tagsSearchResponse = await axiosInstance.get("tags");
      const tags = tagsSearchResponse.data.results;

      const mappedTagOptions = tags.map((tag) => ({
        value: tag.id,
        label: tag.name,
        createdAt: tag.created_at,
      }));

      setTagsOptions(mappedTagOptions); // Directly store mapped values
    };

    const loadNews = async () => {
      const newsByIdResponse = await fetchSingleNews(id);
      const news = newsByIdResponse.data.data;

      const initializedValues = fields.reduce((acc, field) => {
        acc[field.fieldName] = field.getValue
          ? field.getValue(news)
          : news[field.fieldName];
        return acc;
      }, {});

      setValues(initializedValues);
      console.log("settings single news", initializedValues);
    };

    const loadCategories = async () => {
      const fetchCategoriesResponse = await fetchAllCategories({
        page_size: 1000,
      });
      const categoriesOptions = fetchCategoriesResponse.data.results.map(
        (cat) => ({
          value: cat.id,
          label: cat.name,
        })
      );

      setCategories(categoriesOptions);
      console.log("categories loaded");
    };
    const loadData = async () => {
      setIsLoading(true); // Start loading data

      try {
        await loadTagsOptions();
        await loadCategories();
        await loadNews();
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoading(false); // End loading after all data is fetched
      }
    };

    loadData();
  }, []);
  // tags
  const [tagsOptions, setTagsOptions] = useState([]);
  const [tagsLoading, setTagsLoading] = useState(false);

  const [values, setValues] = useState({});

  const [isLoading, setIsLoading] = useState(true);

  const [categories, setCategories] = useState([]);

  // dynamic form
  const meta = {
    gridColumns: {
      small: 1,
      medium: 3,
      large: 4,
    },
  };

  const fields: FieldType = [
    {
      displayed: false,
      title: "عنوان",
      fieldName: "title",
      type: "string",
      validation: (value) => Yup.string().max(255).required(),
      getValue: (row) => row.title || "",
    },
    {
      displayed: false,
      title: "سرتیتر",
      fieldName: "headline",
      type: "string",
      validation: (value) => Yup.string().max(255),
      getValue: (row) => row.headline || "",
    },
    {
      title: "اسلاگ",
      fieldName: "slug",
      type: "string",
      validation: (value) => {
        const re = RegExp(`^[a-z0-9]+(?:(?:-|_)+[a-z0-9]+)*$`);
        if (!re.test(value)) {
          return "فقط حروف انگلیسی و اعداد. با - جدا کنید";
        } else {
          return null;
        }
      },
      onChange: (value) => {
        value.target.value = slugify(value.target.value);
        return value;
      },
    },
    {
      title: "طبقه بندی",
      fieldName: "category",
      type: "selectbox",
      options: categories,
      validation: (value) => Yup.object().required(),
      getValue: (row) => {
        return { value: row.category.id, label: row.category.name } || null;
      },
    },
    {
      title: "نوع",
      fieldName: "type",
      type: "selectbox",
      options: newsTypeOptions.filter((option) => option.value != null),
      validation: (value) => Yup.object().required(),
      getValue: (row) =>
        newsTypeOptions.find((option) => option.value === row.type) || "",
    },
    {
      title: "اولویت",
      fieldName: "priority",
      type: "number",
      validation: (value) => Yup.string(),
    },
    {
      title: "تصویر خبر",
      fieldName: "thumbnail",
      type: "file",
      validation: (files) => {},
      getValue: (row) => row.thumbnail, // Wrap in an array for FilePond
      colSpan: 3,
      ref: React.createRef(), // To trigger file input click
    },
    {
      title: "تگ ها",
      fieldName: "tags",
      type: "custom",
      validation: () => null, // No validation for this field
      getValue: (row) =>
        row.tags.map((tag) => ({ value: tag.id, label: tag.name })), // Map to correct structure
      template: (formik, fieldName) => (
        <AsyncCreatableSelect
          isClearable
          // isDisabled={tagsLoading}
          isMulti
          isLoading={tagsLoading}
          value={formik.values[fieldName]}
          defaultOptions={tagsOptions} // Ensure this is set properly
          onChange={(option) => formik.setFieldValue(fieldName, option)}
          formatCreateLabel={(inputText) => `ساخت "${inputText}"`}
          loadOptions={async (value) => {
            setTagsLoading(true); // Start loading when fetching options
            const tagsSearchResponse = await axiosInstance.get("tags", {
              params: { name: value },
            });
            const tags = tagsSearchResponse.data.results;

            const mappedTagOptions = tags.map((tag) => ({
              value: tag.id,
              label: tag.name,
            }));

            // Update the tagsOptions with newly fetched options
            setTagsOptions((prevOptions) => {
              return [
                ...new Map(
                  [...prevOptions, ...mappedTagOptions].map((item) => [
                    item.value,
                    item,
                  ])
                ).values(),
              ];
            });

            setTagsLoading(false); // End loading after fetching options
            return mappedTagOptions;
          }}
          onCreateOption={async (inputValue) => {
            setTagsLoading(true); // Start loading while creating
            const createTagResponse = await axiosInstance.post("tags", {
              name: inputValue,
            });
            const newTag = {
              value: createTagResponse.data.data.id,
              label: inputValue,
              createdAt: new Date().toISOString(),
            };

            // Update tagsOptions to include the new tag
            setTagsOptions((prev) => {
              let newOptions = [...prev, newTag];
              newOptions.sort((a, b) => {
                return a.createdAt > b.createdAt ? 1 : -1;
              });
              return Array.from(
                new Map(newOptions.map((item) => [item.value, item])).values()
              );
            });

            setTagsLoading(false); // End loading
            await formik.setFieldValue(fieldName, newTag); // Set the new tag in Formik state
            return newTag; // Return the new tag to be added in the select options
          }}
          isRtl
          placeholder="جستجو و انتخاب کنید و در صورت لزوم بسازید"
        />
      ),
    },
    {
      title: "زمان انتشار",
      fieldName: "published_at",
      type: "datepicker",
      validation: (value) => (!value ? "زمان انتشار الزامی است" : null),
      getValue: (row) => {
        return moment(row.published_at).format("jYYYY/jMM/jDD HH:mm:ss");
      },
    },
    {
      title: "پیشنهاد سردبیر",
      fieldName: "editor_suggestion",
      type: "checkbox",
      validation: () => Yup.string().required(),
    },
    {
      title: "فعال",
      fieldName: "is_active",
      type: "checkbox",
      validation: () => Yup.string().required(),
    },
    {
      title: "توضیحات",
      fieldName: "description",
      type: "custom",
      validation: () => Yup.string().required(),
      template: (formik, fieldName) => (
        <div className="w-full">
          <textarea
            className="w-full rounded-lg border p-2"
            onChange={(value) =>
              formik.setFieldValue(fieldName, value.target.value)
            }
            value={formik.values[fieldName]}
          />
        </div>
      ),
      colSpan: 3,
    },
    {
      title: "متن",
      fieldName: "body",
      type: "text-editor",
      validation: () => Yup.string().required(),
      colSpan: 3,
    },
  ];

  const convertToGregorian = (jalaaliDateString) => {
    jalaaliDateString = toEnDigit(jalaaliDateString); // Convert Persian/Arabic digits to English

    // Parse the Jalaali date string with an explicit timezone offset
    const gregorianDate = moment(
      jalaaliDateString,
      "jYYYY-jMM-jDD HH:mm:ss"
    ).utcOffset("+03:30", true); // Adjust for the Iran Standard Time offset

    return gregorianDate.format("YYYY-MM-DDTHH:mm:ssZ"); // Format with the correct timezone
  };

  const updateNewsHandler = async (values) => {
    console.log("values", values);
    console.log(
      "thumbnail value",
      values.thumbnail?.file,
      values.thumbnail["file"]
    );
    const {
      title,
      headline,
      priority,
      description,
      body,
      editor_suggestion,
      type,
      category,
      tags,
      published_at,
      thumbnail,
      slug,
      is_active,
    } = values;

    // Assuming existingFiles contains file objects already uploaded to the server

    const thumbnailFile = values.thumbnail?.file || null;

    console.log("published Date", parseIDayToDateStr(published_at));
    // Construct the edit schema
    let editSchema = {
      title: title,
      description: description,
      author: 1, // Assuming author is set to 0, or you want to pass this dynamically
      body: body,
      editor_suggestion: editor_suggestion,
      type: type.value, // Assuming type comes as an object and you need the value
      category: category.value, // Same here for category
      tags: values.tags.map((t) => t.value).join(","),
      published_at: convertToGregorian(published_at),
      slug: slug,
      is_active: is_active,
      headline: headline,
      priority: priority,
    };
    if (thumbnailFile) {
      editSchema = { ...editSchema, thumbnail: thumbnailFile };
    }
    console.log("trying to update");
    const updateNewsResponse = await updateNews(id, editSchema);
    if (updateNewsResponse.status != 200) {
      throw new Error("خطا در بروزرسانی خبر");
    }
  };

  return (
    !isLoading && (
      <DynamicForm
        fields={fields}
        meta={meta}
        onSubmit={updateNewsHandler}
        values={values}
        showPreviewButton={true}
        previewOnClick={async (values) => {
          values.type = values.type.value;
          values.category = values.category.value;
          values.tags = values.tags?.map((t) => t.value).join(",") || "";
          values.author = 1;
          values.published_at = convertToGregorian(values.published_at);
          values.thumbnail = values.thumbnail?.file || null;
          values.is_preview = true;
          // values.headline = values.headlline
          console.log("Form values:", values);
          const createNewsResponse = await axiosInstance.post("news", values, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (createNewsResponse.status != 201) {
            throw new Error("خطا در ثبت خبر");
          }
          const newNewsId = createNewsResponse.data.data.id;
          window.open(`https://naftkhabar.com/short/${newNewsId}?preview=true`, '_blank')
        //   window.open(
        //     `http://localhost:6574/short/${newNewsId}?preview=true`,
        //     "_blank"
        //   );
        }}
      />
    )
  );
};

export default EditNews;
